




















import { Component, Mixins, Prop } from "vue-property-decorator";
import { IConfiguration } from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { ImageObjectStyleReader } from "../styleReaders";
import {
  ClaioContentDrawableObjectMixin,
  SignExecutableMixin,
  StyledDrawableMixin,
} from "./mixins";
import { SignItem } from "../../../../domain/document/items";
import { DomainRegistry } from "../../../../domain";
import { ImageSourceKinds, ImageKinds, IDocumentImageSource } from "../../../../domain/document";

@Component
export default class SignObject extends Mixins(
  ClaioContentDrawableObjectMixin,
  StyledDrawableMixin,
  SignExecutableMixin,
) {
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new ImageObjectStyleReader(configuration.style.document.editor.objects.sign);
  }

  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  editingSource: SignItem;

  data(): any {
    return {
      imgWidth: null,
      imgHeight: null,
      ratioScale: 0,
    };
  }
  imgWidth: string;
  imgHeight: string;
  ratioScale: number;

  updated() {
    if (!this.editingSource.imageKind) {
      this.imgWidth = null;
      this.imgHeight = null;
      this.ratioScale = null;
    }
  }

  get freeInputStyleProperties(): any {
    return {
      pointerEvents: this.editingSource.isEditable ? null : "none",
    };
  }

  get hasImage(): boolean {
    return ((this.imageSource !== null) && (this.imageSource !== ""));
  }
  
  adjustImageSizeWithRetry(): void {
    this.adjustImageSize();
    this.$nextTick(() => {
      // containerのサイズを正常に取得できていないことがあるので再度設定する
      this.adjustImageSize();
    });
  }

  adjustImageSize(): void {
    const image = this.$refs.image as HTMLImageElement;
    if (!image) { return; }

    const container = this.$refs.container as HTMLElement;
    const rect = container.getBoundingClientRect();
    const ratioWidth = image.naturalWidth / (rect.width > 0 ? rect.width : 1);
    const ratioHeight = image.naturalHeight / (rect.height > 0 ? rect.height : 1);
    const ratioRotateWidth = image.naturalWidth / (rect.height > 0 ? rect.height : 1);
    const ratioRotateHeight = image.naturalHeight / (rect.width > 0 ? rect.width : 1);

    // 比率が大きい方に合わせ、containerにフィットさせる
    this.imgWidth = (ratioWidth >= ratioHeight) ? "100%" : null;
    this.imgHeight = (ratioWidth <= ratioHeight) ? "100%" : null;

    // 回転時の拡大率を算出する
    this.ratioScale = (ratioRotateWidth < ratioRotateHeight)
      ? (ratioWidth > ratioHeight)
        ? image.naturalWidth / image.naturalHeight
        : rect.width / rect.height
      : (ratioWidth < ratioHeight)
        ? image.naturalHeight / image.naturalWidth
        : rect.height / rect.width;
  }

  private async uploadDocumentImage(imageText: string): Promise<void> {
    try {
      const imageGuid = await DomainRegistry.document.getDocumentRepository().uploadDocumentImage(imageText);
      this.$logger.debug("upload done. imageGuid: " + imageGuid);
      this.writeProperty((s: SignItem) => {
        s.clearImageInformation();
        s.imageSource.imageGuid = imageGuid;
        s.imageSource.imageSourceKind = ImageSourceKinds.Cache;
        s.originalImageSource.imageGuid = imageGuid;
        s.originalImageSource.imageSourceKind = ImageSourceKinds.Cache;
        s.imageKind = ImageKinds.Image;
      });
    } catch (e) {
      this.$error(
        "アップロード失敗",
        "ファイルのアップロードに失敗しました。",
        e,
      );
    }
  }
  
  async sign(): Promise<void> {
    if (!this.editingSource.isEditable) {
      return;
    }
    this.emitFocus();
    if (this.$configuration.behavior.document.editor.objects.sign.signTablet.isEnable) {
      await this.executeSign();
    } else {
      const text = await this.commonComponents.dialogs.sign.show(this.editingSource.geometry.rectangle.size);
      if (!text) {
        return;
      }
      await this.uploadDocumentImage(text);
    }
  }

  get rotationStyleProperties(): any {
    if (!this.editingSource.rotationAngle) { return null; }
    if (!this.ratioScale) { return null; }
    const transformText = "rotate(" + this.editingSource.rotationAngle + "deg) " + this.getScaleText(this.editingSource.rotationAngle);
    return {
      transform: transformText,
    };
  }

  getScaleText(angle: number): string {
    return ((angle % 180 !== 0) && this.ratioScale)
      ? "scale(" + this.ratioScale + ")"
      : "";
  }

  get maxSizeStyleProperties(): any {
    return {
      maxWidth: this.size.width + "px",
      maxHeight: this.size.height + "px",
    };
  }

  clearImage(): void {
    const repository = DomainRegistry.document.getDocumentRepository();
    repository.createEmptyImageSource()
    .then(source => {
      this.writeProperty((s: SignItem) => {
        s.clearImageInformation();
        s.replaceImageSource(source);
      });
    });
  }
}
